import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import {
  ArchiveLeaveTypeDocument,
  ArchiveLeaveTypeModalDocument,
  ArchiveLeaveTypeMutation, // LeaveTypeFragment,
} from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  leaveTypeId: number
  onClose: () => void
}

const ArchiveLeaveTypeModal = ({ leaveTypeId, onClose }: Props) => {
  const { data } = useQuery(ArchiveLeaveTypeModalDocument, { variables: { id: leaveTypeId } })
  const leaveType = data?.timeoff?.leaveType

  const [archiveLeaveTypeMutation] = useMutation(ArchiveLeaveTypeDocument, {
    extractorFn: (mutationData: ArchiveLeaveTypeMutation) =>
      mutationData.timeoffMutations.updateTimeoffLeaveType,
  })

  const onSubmit = async (closePortal: ClosePortalFn) => {
    if (!leaveType) return

    const result = await archiveLeaveTypeMutation({
      variables: { id: leaveType.id, active: false },
    })

    const handled = handleResult(result, () => {})

    if (handled.success) {
      closePortal()
    }

    return handled
  }

  return (
    <Modal
      illustration="document-folder-drawer-2"
      title={i18n.t('settings.leave_types.archive.title')}
      description={i18n.t('settings.leave_types.archive.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Button type="negative" submit>
          {i18n.t('common.confirm')}
        </Button>
      }
    />
  )
}

export default ArchiveLeaveTypeModal
